import {isObject} from "../services/utils";

export default {
    bind(el, binding, vnode) {
        let value = binding.value;
        let delay = 0;
        let duration = 0.5;
        let offsetHeight = false
        let autoDisplay = false
        if(isObject(binding.value)) {
            value = binding.value.transition
            duration = binding.value.duration
            delay = binding.value.delay || 0
            offsetHeight = !!binding.value.offsetHeight
            autoDisplay = !!binding.value.autoDisplay
        }
        el.classList.add(`${value}-before-enter`)


        let f = () => {
            let rect = el.getBoundingClientRect()
            let offset = 0;
            if(offsetHeight) {
                offset = rect.height;
            }
            let inView = (
                rect.width > 0 &&
                rect.height > 0 &&
                rect.top >= 0 &&
                (rect.bottom + offset - ( rect.height * 0.8)) <= (window.innerHeight || document.documentElement.clientHeight)
            )
            if (inView) {
                el.classList.add(value)
                // window.removeEventListener('scroll', f)


                setTimeout(() => {
                    el.style.removeProperty('transition-delay')
                    el.style.removeProperty('transition-duration')
                    el.style.setProperty('transition-duration', '0.05s')
                }, 50)
            } else {
              el.classList.remove(value)
              if(delay) {
                el.style.setProperty('transition-delay', `${delay}ms`)
              }
              el.style.setProperty('transition-duration', `${duration}s`)
              el.style.setProperty('transition-property', 'all')
              el.style.setProperty('transition-timing-function', 'ease')
            }
        }
        if(delay) {
            el.style.setProperty('transition-delay', `${delay}ms`)
        }

        el.style.setProperty('transition-duration', `${duration}s`)
        el.style.setProperty('transition-property', 'all')
        el.style.setProperty('transition-timing-function', 'ease')
        if(!autoDisplay) {
            window.addEventListener('scroll', f)
            setTimeout(() => {
                f()
            }, 300)
        } else {
            setTimeout(() => {
                el.classList.add(value)
                setTimeout(() => {
                    el.style.removeProperty('transition-delay')
                    el.style.removeProperty('transition-duration')
                }, 500)
            }, 300)
        }
    },

    mounted(el, binding) {
        let value = binding.value;
        let delay = 0;
        if(isObject(binding.value)) {
            value = binding.value.transition
            delay = binding.value.delay
        }
        el.classList.add(`${value}-before-enter`)
    }
}
